var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortDownDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "30px",
    viewBox: "0 0 55 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sort-up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sort-up"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#24303B",
    x: 0.5,
    y: 0.5,
    width: 54,
    height: 29,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.905,11.5 L39.513,15.761 L40.431,14.881 L44.073,11.545 L45.5,12.914 C43.386,14.943 41.485,16.607 39.513,18.5 C38.047,17.094 33.5,12.89 33.5,12.89 L34.905,11.5 L34.905,11.5 Z M24.5,14.767 L18.843,9.5 L17.429,10.717 L20.672,13.726 L9.5,13.726 L9.5,15.685 L20.672,15.685 L17.429,19.03 L18.843,20.5 L24.5,14.767 Z",
    id: "Shape",
    fill: "#24303B",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDownDark);
export default __webpack_public_path__ + "static/media/sort-down-dark.fb3b64c5.svg";
export { ForwardRef as ReactComponent };